<template>
  <div>
    <div class="row reverse-mobile">
      <div id="left-menu" class="col-12 col-md-3">
        <CommunityCard :withHorizontalRules="false">
          <div class="isim-community-card-header">
            <h5 class="m-0">Search</h5>
          </div>

          <ul class="list-group">
            <a href="javascript:void(0)" @click="updateTab(PAGE_TABS.ALL)">
              <li class="list-group-item d-flex align-items-center">
                <img class="mr-2" width="24" height="24"
                  :src="
                    currentTab == PAGE_TABS.ALL
                      ? require('../assets/nav-icons/provision-device-fill.svg')
                      : require('../assets/nav-icons/provision-device.svg')
                  "
                />
                All
              </li>
            </a>
            <div v-if="isAdmin">
              <a href="javascript:void(0)" @click="updateTab(PAGE_TABS.USERS)">
                <li class="list-group-item d-flex align-items-center">
                  <img class="mr-2" width="24" height="24"
                    :src="
                      currentTab == PAGE_TABS.USERS
                        ? require('../assets/nav-icons/my-profile-fill.svg')
                        : require('../assets/nav-icons/my-profile.svg')
                    "
                  />
                  Users
                </li>
              </a>
            </div>
            <a href="javascript:void(0)" @click="updateTab(PAGE_TABS.POSTS)">
              <li class="list-group-item d-flex align-items-center">
                <img class="mr-2" width="24" height="24"
                  :src="
                    currentTab == PAGE_TABS.POSTS
                      ? require('../assets/nav-icons/update-details-fill.svg')
                      : require('../assets/nav-icons/update-details.svg')
                  "
                />
                Posts
              </li>
            </a>
            <a href="javascript:void(0)" @click="updateTab(PAGE_TABS.GROUPS)">
              <li class="list-group-item d-flex align-items-center">
                <img class="mr-2" width="24" height="24"
                  :src="
                    currentTab == PAGE_TABS.GROUPS
                      ? require('../assets/nav-icons/my-groups-fill.svg')
                      : require('../assets/nav-icons/my-groups.svg')
                  "
                />
                Groups
              </li>
            </a>
          </ul>
        </CommunityCard>
      </div>

      <div class="col-12 col-md-9 center-content">
        <CommunityCard class="p-4">
          <div v-if="isLoadingUsers || isLoadingPosts || isLoadingGroups" class="w-75 d-flex flex-column justify-content-center align-items-center small-full">
            <PleaseWait></PleaseWait>
          </div>

          <div
            v-if="!isLoadingUsers && !isLoadingPosts && !isLoadingGroups && 
                  ((currentTab === PAGE_TABS.ALL && users.length == 0 && posts.length == 0 && groups.length == 0) ||
                   (currentTab === PAGE_TABS.USERS && users.length == 0) ||
                   (currentTab === PAGE_TABS.POSTS && posts.length == 0) ||
                   (currentTab === PAGE_TABS.GROUPS && groups.length == 0))"
            class="w-75 d-flex flex-column justify-content-center align-items-center small-full m-auto"
          >
            <NoResults></NoResults>
          </div>

          <div v-if="(users.length > 0 || posts.length > 0 || groups.length)  && !isLoadingUsers && !isLoadingPosts && !isLoadingGroups">
            <ul v-if="users.length > 0  && (currentTab === PAGE_TABS.ALL || currentTab === PAGE_TABS.USERS)" style="list-style-type: none; padding-left: 0px;">
              <div v-if="currentTab === PAGE_TABS.ALL">Top 5 user results:</div>
              <li v-for="user in users" v-bind:key="`User-${user.id}`">
                <UserCard :user="user" :includeActions="false" />
              </li>
            </ul>
            <ul v-if="posts.length > 0  && (currentTab === PAGE_TABS.ALL || currentTab === PAGE_TABS.POSTS)" style="list-style-type: none; padding-left: 0px;">
              <div v-if="currentTab === PAGE_TABS.ALL">Top 5 post results:</div>
              <ForumPost
                v-for="post in posts"
                :key="post.id"
                :postObj="post"
                :groupObj="post.group"
              ></ForumPost>
            </ul>
            <ul v-if="groups.length > 0  && (currentTab === PAGE_TABS.ALL || currentTab === PAGE_TABS.GROUPS)" style="list-style-type: none; padding-left: 0px;">
              <div v-if="currentTab === PAGE_TABS.ALL">Top 5 group results:</div>
              <li v-for="group in groups" v-bind:key="`Group-${group.id}`">
                <div class="group-card">
                  <div class="titlerow">
                    <div class="title-text">
                      <h5 class="d-inline-block" style="padding: 6px;">
                        <a
                          v-if="group.userIsMember"
                          href="javascript:void(0)"
                          @click="goToGroup(group.id)"
                        >
                          {{ group.name }}
                        </a>
                        <template v-else>{{ group.name }}</template>
                      </h5>
                      <div class="title-creator" style="padding: 6px;">{{ group.description }}</div>
                    </div>
                    <div>
                      <button v-if="group.userIsMember === false && group.isInviteOnly === false" @click="joinOpenGroup(group)" class="btn btn-primary w-100">
                        Join Group
                      </button>
                      <button v-if="group.userIsMember === false && group.isInviteOnly === true && group.joinRequestSent === false" @click="requestToJoinGroup(group)" class="btn btn-primary w-100">
                        Request to Join
                      </button>
                      <button v-if="group.userIsMember === false && group.isInviteOnly === true && group.joinRequestSent === true" class="btn btn-disabled w-100">
                        Request Sent
                      </button>
                      <button v-if="group.userIsMember === true" class="btn btn-disabled w-100">
                        Already Member
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <div v-if="currentTab !== PAGE_TABS.ALL" class="row d-flex justify-content-center">
              <div v-if="resultCount > 0" class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5">
                <template>
                  <paginate
                    v-model="page"
                    :page-count="pageCount"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                  ></paginate>
                </template>
              </div>
            </div>

          </div>
        </CommunityCard>
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import SearchService from "../services/search.service";
import ForumGroupService from "../services/forumgroup.service";
import Paginate from "../components/Paginate";
import PleaseWait from "../components/PleaseWait";
import NoResults from "../components/NoResults";
import UserCard from "../components/UserCard";
import ForumPost from "../components/ForumPost";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";
import { GroupMembershipType, Role } from "../utils/user.helper";

export default {
  name: "Search",
  components: {
    Paginate,
    PleaseWait,
    NoResults,
    UserCard,
    ForumPost,
    CommunityCard,
    Footer,
  },
  data: function() {
    return {
      isLoadingUsers: true,
      isLoadingPosts: true,
      isLoadingGroups: true,
      users: [],
      posts: [],
      groups: [],
      resultCount: 0,
      NUMBER_TO_GET: 20,
      pageCount: 0,
      page: 0,
      from: 0,
      to: 0,
      pageNum: 0,
      PAGE_TABS: {
        ALL: "All",
        USERS: "Users",
        POSTS: "Posts",
        GROUPS: "Groups",
      },
      currentTab: "All"
    };
  },
  methods: {
    update() {
      if (this.currentTab === this.PAGE_TABS.ALL) {
        this.searchAll();
      } else if (this.currentTab === this.PAGE_TABS.USERS) {
        this.searchUsers(this.pageNum * this.NUMBER_TO_GET, this.NUMBER_TO_GET);
      } else if (this.currentTab === this.PAGE_TABS.POSTS) {
        this.searchPosts(this.pageNum * this.NUMBER_TO_GET, this.NUMBER_TO_GET);
      } else if (this.currentTab === this.PAGE_TABS.GROUPS) {
        this.searchGroups(this.pageNum * this.NUMBER_TO_GET, this.NUMBER_TO_GET);
      }
    },

    searchAll() {
      this.searchUsers(this.pageNum * 5, 5);
      this.searchPosts(this.pageNum * 5, 5);
      this.searchGroups(this.pageNum * 5, 5);
    },

    searchUsers(startAt, numberToTake) {
      if (!this.isAdmin) {
        this.isLoadingUsers = false;
        return;
      }

      this.isLoadingUsers = true;
      SearchService.searchUsers(startAt, numberToTake, this.$store.getters.getSearchTerm)
        .then(data => {
          this.users = data.users;
          this.resultCount = data.count;
          this.from = parseInt(data.from);
          this.to = parseInt(data.to);
          this.updatePageCount();
          this.isLoadingUsers = false;
        });
    },

    searchPosts(startAt, numberToTake) {
      this.isLoadingPosts = true;
      SearchService.searchPosts(startAt, numberToTake, this.$store.getters.getSearchTerm)
        .then(data => {
          this.posts = data.posts;
          this.resultCount = data.count;
          this.from = parseInt(data.from);
          this.to = parseInt(data.to);
          this.updatePageCount();
          this.isLoadingPosts = false;
        });
    },
    
    searchGroups(startAt, numberToTake) {
      this.isLoadingGroups = true;
      SearchService.searchGroups(startAt, numberToTake, this.$store.getters.getSearchTerm)
        .then(data => {
          this.groups = data.groups;
          this.resultCount = data.count;
          this.from = parseInt(data.from);
          this.to = parseInt(data.to);
          this.updatePageCount();
          this.isLoadingGroups = false;

          this.groups.forEach(function(group) {
            group.isInviteOnly = group.membership_type === GroupMembershipType.InviteOnly;
          });
        });
    },

    clickCallback: function(pageNum) {
      this.isActive = true;

      window.scrollTo(0, 0);
      this.page = pageNum;
      this.pageNum = pageNum - 1;
      this.users = [];
      this.posts = [];
      this.groups = [];
      this.update();
    },

    updatePageCount() {
      this.pageCount = Math.ceil(this.resultCount / this.NUMBER_TO_GET);
    },

    updateTab(tab) {
      this.currentTab = tab;
      this.update();
    },

    goToGroup(groupId) {
      this.$router.push({
        name: "forum-group",
        params: { groupId: groupId },
      });
    },

    joinOpenGroup(group) {
      group.userIsMember = true;
      ForumGroupService.joinOpenGroup(group.id);
    },

    requestToJoinGroup(group) {
      group.joinRequestSent = true;
      ForumGroupService.requestToJoinGroup(group.id);
    },
  },
  mounted() {
    this.update();
  },
  computed: {
    isAdmin() {
      return (this.$store.getters.getUserRole & Role.Admin) !== 0;
    },
  },
  watch: {
    "$store.state.searchTerm": function() {
      this.update();
    }
  }
};
</script>


<style scoped>
.results-count {
  color: var(--isim-light-text);
  font-size: 14px;
  text-align: center;
}
.titlerow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.group-card {
  border: 1px solid #ddd;
  padding: 6px;
  border-radius: 4px;
  margin: 16px auto;
}
.list-group-item {
  border: none;
  margin-bottom: 5px;
  color: var(--isim-light-text);
  margin-left: 0px;
  background: #ffffff;
  max-height: 2.2rem;
}
</style>